import '@progress/kendo-theme-bootstrap/dist/all.css';
import './App.css';

import { useState } from 'react';

import { Form } from '@progress/kendo-react-form';

import DistributionGrid from './components/DistributionGrid';
import SubscriberDistributionForm from './components/SubscriberDistributionForm';
import { DistributionGridSelectionContext } from './context/DistributionGridSelectionContext';
import { useUpdateDistributionDetails } from './hooks/AuditHooks';
import { UpdateDistributionDetailsRequest } from './models/api/UpdateDistributionDetailsRequest';

function App() {
  const params = new URLSearchParams(window.location.search);
  const token = params.get('token') ?? '';
  const aud = params.get('aud') ?? '';
  const hideSubscriberDistribution = aud === 'accountManager';

  const [selectedAuditIds, setSelectedAuditIds] = useState<number[]>([]);
  const updateDistributionMutation = useUpdateDistributionDetails();

  const handleSubmit = (dataItem) => {
    // dataItem should contain subscriberDistributionDate and methodOfDistribution
    const subscriberDistributionDate = dataItem.subscriberDistributionDate;
    const distributionMethod =
      dataItem.methodOfDistribution?.name || dataItem.methodOfDistribution;
    const otherMethod = dataItem.otherMethod || null;
    if (!selectedAuditIds.length) {
      window.alert('Please select at least one SBC from the list.');
      return;
    }
    const req: UpdateDistributionDetailsRequest = {
      auditIds: selectedAuditIds,
      subscriberDistributionDate,
      distributionMethod,
      otherMethod,
      token,
      aud,
    };
    updateDistributionMutation.mutate(req, {
      onSuccess: () => {
        window.alert('Distribution details submitted successfully.');
      },
      onError: (error) => {
        console.error(error);
        window.alert(
          'An error occurred while submitting distribution details. Please try again later.'
        );
      },
    });
  };

  return (
    <DistributionGridSelectionContext.Provider
      value={{ selectedAuditIds, setSelectedAuditIds }}
    >
      <div className="app">
        <header className="app-header">
          <div className="header-content">
            <img src="/Aetna_Logo.png" alt="Aetna" className="logo" />
            <h1>PLAN SPONSOR SBC PORTAL</h1>
          </div>
        </header>

        <main className="app-main">
          <div className="content-section">
            <h2 className="section-title">Distribution to Subscribers</h2>

            <div className="welcome-section">
              <h3>WELCOME TO THE SBC PLAN SPONSOR PORTAL</h3>
            </div>

            <div className="instructions">
              <p>Before distributing SBCs, review the benefits for accuracy.</p>
              <ul>
                <li>
                  <span className="blue-text">IF ACCURATE</span>, proceed with
                  distribution to your subscribers.
                </li>
                <ul>
                  <li>Enter the &quot;Date Distributed to Subscribers&quot;.</li>
                  <li>
                    Select the &quot;Method of Distribution&quot; from the dropdown menu.
                  </li>
                  <li>Next, click on the Submit Subscriber Distribution Details.</li>
                </ul>
              </ul>
              <li>
                <span className="blue-text">IF UPDATES ARE NEEDED</span>, contact your
                Aetna Account Representative. Do not distribute until updated SBC(s) are
                received.
              </li>
            </div>

            <Form
              onSubmit={handleSubmit}
              initialValues={{
                subscriberDistributionDate: null,
                methodOfDistribution: { name: 'Email', id: 1 },
              }}
              render={(formRenderProps) => (
                <>
                  <div className="form-section">
                    <DistributionGrid />
                  </div>

                  {!hideSubscriberDistribution && (
                    <SubscriberDistributionForm formRenderProps={formRenderProps} />
                  )}
                </>
              )}
            />
          </div>
        </main>
      </div>
    </DistributionGridSelectionContext.Provider>
  );
}

export default App;
